import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useRouter } from 'expo-router';

interface NavBackButtonProps {
  onPress?: () => void;
}

export function NavBackButton({ onPress }: NavBackButtonProps) {
  const router = useRouter();

  const handlePress = onPress ?? (() => router.back());

  return (
    <TouchableOpacity onPress={handlePress} style={{ marginLeft: 8, padding: 4 }}>
      <Ionicons name="chevron-back" size={24} color="#fff" />
    </TouchableOpacity>
  );
}
